import iconTableOfContent from './images/detail/iconTableOfContent.svg';
import iconEditBorder from './images/createPost/iconEditBorder.svg';

export const imageSecond = {
  iconTableOfContent,
  iconEditBorder,
};
